var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-row',[_c('b-col',[_c('pos-product-list',{attrs:{"systemid":1}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }